import React, {useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import {useTranslation} from 'react-i18next';
import {StyledTransactionDetails} from './StyledTransactionDetails';
import InvoiceDetailsPanel from '../InvoiceDetailsPanel';
import TransactionDetailsHeader from '../TransactionDetailsHeader';
import ExpenseDetails from '../../ExpensesPage/ExpenseDetailsPanelTabs/tabComponents/ExpenseDetails';
import {expenseActions} from '../../../../state/actions/expense.actions';
import {cardPaymentStatusesConstants, transactionTypesConstants} from '../../../../constants';
import {objectHelpers} from '../../../../utils/helpers';
import {alertActions} from '../../../../state/actions/alert.actions';

const TransactionDetails = ({
  dispatch,
  getExpense,
  updateExpense,

  edit = true,
  subscription,
  transaction,
  onExpenseUpdate,
  onInvoiceRemove,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [expense, setExpense] = useState(undefined);
  const isPayInType = useMemo(() => {
    return objectHelpers.getObjProp(transaction, 'transaction_type') === transactionTypesConstants.PAY_IN;
  }, [transaction]);

  const isDeclined = useMemo(() => transaction?.payment_status === cardPaymentStatusesConstants.DECLINED, [transaction]);

  const isEnabledInvoiceDetails = useMemo(() => !isPayInType && !isDeclined && Boolean(parseFloat(transaction?.amount)), [isDeclined, isPayInType, transaction]);

  useEffect(() => {
    const expenseId = transaction?.expense_id;
    if (!expenseId) return;

    getExpense({
      id: expenseId,
      successCallback: setExpense,
      errorCallback: () => setExpense(null)
    });
  }, [transaction?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUpdateExpense = (expense, type) => {
    setExpense(expense);
    onExpenseUpdate?.(expense, type);
  }

  const handleEditExpense = (data) => {
    const id = expense?.id;
    if (!id) return;

    updateExpense({
      id,
      data,
      successCallback: handleUpdateExpense,
      errorCallback: (response) => {
        const message = response?.data?.message || response?.response?.data?.message || t('expenses:validation.updateExpenseError');
        alertActions.error(message);
      },
    })
  }

  const handleRemoveInvoice = (successCallback, errorCallback) => {
    onInvoiceRemove?.(
      (response) => {
        successCallback?.(response);
        setExpense({...expense, attachment_url: null, expense_type: null});
      },
      errorCallback
    );
  }

  return (
    <StyledTransactionDetails size='middle' {...rest}>
      <TransactionDetailsHeader
        subscription={subscription}
        transaction={transaction}
      />
      {isEnabledInvoiceDetails && (
        <InvoiceDetailsPanel
          edit={edit}
          expense={expense}
          onExpenseUpdate={handleUpdateExpense}
          onInvoiceRemove={handleRemoveInvoice}
        />
      )}
      <ExpenseDetails
        availableLink={true}
        expense={expense}
        onEdit={handleEditExpense}
      />
    </StyledTransactionDetails>
  );
}

TransactionDetails.propTypes = {
  edit: PropTypes.bool,
  onExpenseUpdate: PropTypes.func,
  onInvoiceRemove: PropTypes.func,
  transaction: PropTypes.object
}

const mapDispatchToProps = {
  getExpense: expenseActions.getExpense,
  updateExpense: expenseActions.updateExpense,
}

export default connect(null, mapDispatchToProps)(TransactionDetails);
